import Icon from "./icon";
import { RowContainer } from "./description";

function Footer({ showBack=true, showNext=true, ...props }) {
	return (
		<RowContainer style={{ justifyContent: "center", marginTop: "2rem" }}>
			{showBack && <Icon viewBox="0 0 96 96" icon="back" size={20} stroke="#004ECC" color="#004ECC" cursor="pointer" marginRight="1rem" onClick={props.backClick} tooltipText="Previous question" />}
			{showNext && <Icon viewBox="0 0 96 96" icon="forward" size={20} stroke="#004ECC" cursor="pointer" color="#004ECC" onClick={props.forwardClick} tooltipText="Next question" />}
		</RowContainer>
	);
}

export default Footer;
